module.exports = __webpack_public_path__ + "static/about-60ff6e4ea696c14c7cc3500e7f7e0b0e.mp4";